import { Resource } from "permissions/entities/permission/resources/general";

export default class ResourceInfoAPIResponse {
  resourceId?: string;
  rawText?: string;
  resourceType?: string;
  accessLevel?: number;
  scope?: number;
  accessType?: number;
  fields?: Record<string, number>;
  isDisabled?: boolean;

  public async deserialize<T extends Resource>(): Promise<T> {
    if (!this.resourceType) {
      throw new Error("ResourceInfo resourceType not returned.");
    }
    if (!this.rawText) {
      throw new Error("ResourceInfo rawText not returned.");
    }

    return await Resource.fromJSON(this.rawText) as T;
  }
}
